export default __webpack_public_path__ + "static/eauchaude-b4a7779726d4537cc746877dc5b21cff.jpg";